// function to check the slot content. If more than one element is in the slot, select the element and delete the rest
export const checkSlotContent = (slot: HTMLElement, selector: string) => {
  if (slot && slot.children.length > 1) {
    const neededElement = slot.querySelector(selector);
    if (neededElement) {
      slot.innerHTML = '';
      slot.appendChild(neededElement);
    }
  }
};
